import {
  TextInput,
  type TextInputProps,
} from "@circleco/compass/components/TextInput";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { validateCanonicalUrl } from "@/react/helpers/postCanonicalUrl";
import { useCanEditCanonicalUrl } from "@/react/hooks/useCanEditCanonicalUrl";

interface PostCanonicalUrlFormValues {
  meta_tag_attributes?: {
    canonical_url?: string | null;
  };
}

interface PostCanonicalUrlFieldProps {
  horizontalLayoutRatio?: TextInputProps["horizontalLayoutRatio"];
  id?: string;
  label?: TextInputProps["label"];
  layout?: "horizontal" | "vertical";
  rootClassName?: string;
  validateOnChange?: boolean;
}

export const PostCanonicalUrlField = ({
  horizontalLayoutRatio = "33/67",
  id,
  label = t("meta_tag_attributes.canonical_url"),
  layout = "vertical",
  rootClassName,
  validateOnChange = false,
}: PostCanonicalUrlFieldProps) => {
  const { register, getFieldState, formState, trigger } =
    useFormContext<PostCanonicalUrlFormValues>();
  const canEditCanonicalUrl = useCanEditCanonicalUrl();
  const name = "meta_tag_attributes.canonical_url";
  const { error } = getFieldState(name, formState);

  if (!canEditCanonicalUrl) {
    return null;
  }

  return (
    <TextInput
      {...register(name, {
        validate: validateCanonicalUrl,
        onChange: validateOnChange
          ? () => {
              void trigger(name);
            }
          : undefined,
      })}
      id={id}
      label={label}
      labelTooltip={t("meta_tag_attributes.canonical_url_description")}
      layout={layout}
      rootClassName={rootClassName}
      horizontalLayoutRatio={horizontalLayoutRatio}
      invalid={Boolean(error)}
      error={error?.message}
      placeholder={t("meta_tag_attributes.canonical_url_placeholder")}
    />
  );
};
